import InlineAdProcessor from './inlineAdProcessor';
import { type Article } from '~/types/article';
import { type PublicationContext } from '~/types';
import InlineBrazeBannerCardProcessor from '~/helper/article/processors/bodyProcessor/inlineBrazeBannerCardProcessor';
import InlineWordExplainerProcessor from '~/helper/article/processors/bodyProcessor/inlineWordExplainerProcessor';

export default class BodyProcessor {
  private bodyProcessors: any[];
  private readonly publicationContext: PublicationContext;
  protected readonly articleAdConfig: any;

  constructor (publicationContext: PublicationContext, articleAdConfig: any) {
    this.publicationContext = publicationContext;
    this.articleAdConfig = articleAdConfig;
    this.bodyProcessors = [
      new InlineAdProcessor(this.articleAdConfig),
      new InlineBrazeBannerCardProcessor(),
      new InlineWordExplainerProcessor()
    ];
  }

  process (article: Article) {
    for (let idx = 0; idx < this.bodyProcessors?.length; idx += 1) {
      try {
        this.bodyProcessors[idx].process(article, this.publicationContext);
      } catch (err) {

      }
    }
  }
}
